var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHide(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.41771C12.3 3.41771 14.1667 5.28437 14.1667 7.58437C14.1667 8.00937 14.0833 8.41771 13.9667 8.80104L16.5167 11.351C17.675 10.326 18.5917 9.04271 19.1667 7.57604C17.725 3.92604 14.1667 1.33437 10 1.33437C8.94167 1.33437 7.925 1.50104 6.96667 1.80938L8.775 3.61771C9.16667 3.50104 9.575 3.41771 10 3.41771ZM2.25834 0.634375C1.93334 0.959375 1.93334 1.48438 2.25834 1.80938L3.9 3.45104C2.55 4.52604 1.475 5.94271 0.833336 7.58437C2.275 11.2427 5.83334 13.8344 10 13.8344C11.2667 13.8344 12.475 13.5844 13.5917 13.151L15.8583 15.4177C16.1833 15.7427 16.7083 15.7427 17.0333 15.4177C17.3583 15.0927 17.3583 14.5677 17.0333 14.2427L3.44167 0.634375C3.11667 0.309375 2.58334 0.309375 2.25834 0.634375ZM10 11.751C7.7 11.751 5.83334 9.88437 5.83334 7.58437C5.83334 6.94271 5.98334 6.33437 6.24167 5.80104L7.55 7.10938C7.525 7.25937 7.5 7.41771 7.5 7.58437C7.5 8.96771 8.61667 10.0844 10 10.0844C10.1667 10.0844 10.3167 10.0594 10.475 10.026L11.7833 11.3344C11.2417 11.601 10.6417 11.751 10 11.751ZM12.475 7.30937C12.35 6.14271 11.4333 5.23437 10.275 5.10937L12.475 7.30937Z",
    fill: "url(#paint0_linear_8323_45982)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8323_45982",
    x1: 19.1649,
    y1: 7.95398,
    x2: -0.118614,
    y2: 7.95398,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#003049"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#005887"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHide);
export default __webpack_public_path__ + "static/media/hide.b5c15ee90ac25a2a04a448fd9731a9f5.svg";
export { ForwardRef as ReactComponent };